// ===========================================
// konakla - Image URL Variants Helper
// ===========================================
//
// Strateji (2026-04-18 güncelleme):
// - Proje Supabase Free tier'da çalışıyor; `/storage/v1/render/image/...`
//   transform endpoint'i Pro+ gerektirdiği için 403 döndürüyordu. Bu yüzden
//   tüm varyantlar artık **raw `/object/public/...` URL'ini değiştirmeden**
//   döndürür. Resize/quality optimizasyonunu Next.js'in kendi image
//   optimizer'ı (`/_next/image`) yapıyor — next.config.ts'de `*.supabase.co`
//   remote pattern tanımlı, `<Image fill + sizes>` prop'ları her karşılaşan
//   komponentte var, kalite kaybı yok.
// - API yüzeyi değiştirilmedi: `getThumbnailUrl / getMediumUrl / getLargeUrl`
//   aynı imzada, caller'lar etkilenmez.
// - İleride Pro plan'a geçilirse bu dosyada tek bir flag ile transform tekrar
//   açılabilir (şu an ihtiyaç yok).

/**
 * Orijinal URL'i aynen döner. Geçerli bir string yoksa boş string.
 */
function identity(originalUrl: string | null | undefined): string {
  return originalUrl ?? "";
}

/**
 * Liste/grid kartlarında kullanılan küçük thumbnail.
 * Next/Image `sizes` prop'u ile otomatik optimize edilir.
 */
export function getThumbnailUrl(originalUrl: string | null | undefined): string {
  return identity(originalUrl);
}

/**
 * Orta boyut. Detay sayfalarındaki orta görseller, benzer ilanlar.
 */
export function getMediumUrl(originalUrl: string | null | undefined): string {
  return identity(originalUrl);
}

/**
 * Büyük boyut. İlan detay galerisi, lightbox.
 */
export function getLargeUrl(originalUrl: string | null | undefined): string {
  return identity(originalUrl);
}

/**
 * Bir görsel için tüm varyantları döner. Mobile client'lar response'ta
 * kullanabilir; web'de Next/Image kendi optimize ediyor.
 */
export function getImageVariants(originalUrl: string | null | undefined) {
  const src = originalUrl || "";
  return {
    original: src,
    thumbnail: src,
    medium: src,
    large: src,
  };
}
